<script setup lang="ts">
import ReferenceStatus from '@/components/references/ReferenceStatus.vue'
import ReferenceTitle from '@/components/references/ReferenceTitle.vue'

interface Props {
  /** The reference item to display */
  item: ReferenceInterface
}

defineProps<Props>()

defineOptions({
  name: 'ReferenceDatatableMobileRow'
})
</script>

<template>
  <td class="px-3! py-2!">
    <div class="flex flex-col">
      <div class="flex flex-row justify-between gap-x-3">
        <ReferenceTitle :title="item.title" />
        <slot name="badge" :item />
      </div>

      <div class="flex flex-row items-end justify-between gap-x-3">
        <div class="flex flex-col items-start text-sm">
          <slot name="date" :date="item.date" />
          <slot
            v-if="item.description"
            name="description"
            :description="item.description"
          >
            <p class="text-wrap">{{ item.description }}</p>
          </slot>

          <ReferenceStatus :status="item.status">
            <template #default>
              <slot name="status" :status="item.status" />
            </template>
          </ReferenceStatus>
        </div>
        <slot name="actions" :actions="item.actions" />
      </div>
    </div>
  </td>
</template>
